"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreAddressesStepToJSON = exports.PreAddressesStepFromJSONTyped = exports.PreAddressesStepFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function PreAddressesStepFromJSON(json) {
    return PreAddressesStepFromJSONTyped(json, false);
}
exports.PreAddressesStepFromJSON = PreAddressesStepFromJSON;
function PreAddressesStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mailingAddress': _1.AddressFromJSON(json['mailingAddress']),
        'useDifferentResidentialAddress': json['useDifferentResidentialAddress'],
        'residentialAddress': !runtime_1.exists(json, 'residentialAddress') ? undefined : _1.AddressFromJSON(json['residentialAddress']),
        'atCurrentAddressMoreThanFiveYears': json['atCurrentAddressMoreThanFiveYears'],
        'previousAddress': !runtime_1.exists(json, 'previousAddress') ? undefined : _1.AddressFromJSON(json['previousAddress']),
    };
}
exports.PreAddressesStepFromJSONTyped = PreAddressesStepFromJSONTyped;
function PreAddressesStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mailingAddress': _1.AddressToJSON(value.mailingAddress),
        'useDifferentResidentialAddress': value.useDifferentResidentialAddress,
        'residentialAddress': _1.AddressToJSON(value.residentialAddress),
        'atCurrentAddressMoreThanFiveYears': value.atCurrentAddressMoreThanFiveYears,
        'previousAddress': _1.AddressToJSON(value.previousAddress),
    };
}
exports.PreAddressesStepToJSON = PreAddressesStepToJSON;
//# sourceMappingURL=PreAddressesStep.js.map